<template>
  <div class="error-container">
    <div v-if="isProd" class="error">
      <div class="error__header">Life is like a box of chocolates</div>
      <div class="error__tip">You never know what error you're going to get.</div>
      <div class="error__button">
        <BravadoButtonV3 size="md" variant="accent" @click="$router.push($pages.WAR_ROOM_POSTS_TAB_MYFEED_PAGE.path)">
          take me back
        </BravadoButtonV3>
      </div>
      <img
        src="./assets/error.webp"
        width="750"
        height="492"
        class="error__img"
        alt="logo showing that an error occurred"
      />
    </div>
    <div v-else class="__nuxt-error-page">
      <div class="error">
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="#DBE1EC" viewBox="0 0 48 48">
          <path
            d="M22 30h4v4h-4zm0-16h4v12h-4zm1.99-10C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z"
          />
        </svg>

        <div class="title">{{ error.statusCode }}</div>
        <div class="title">{{ error.message }}</div>
        <p class="description">
          <NuxtLink class="error-link" to="/">Back to home page</NuxtLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default {
  name: 'ErrorLayout',
  components: { BravadoButtonV3 },
  layout: 'clear',
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isProd: process.env.isProduction,
    };
  },
};
</script>

<style lang="scss" scoped>
.error-container {
  background: var(--universal-color-white);
}

.error {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  height: auto;
  min-height: 100vh;
  background: #fff;
  font-family: var(--font-family);
  box-sizing: border-box;
  padding: 159px 242px 0 242px;
  color: #000;

  &__header {
    font-size: 36px;
    font-weight: 300;
    margin-bottom: 9px;
  }

  &__tip {
    color: rgba(0, 0, 0, 0.54);
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 38px;
  }

  &__img {
    width: 750px;
    max-width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: 0;
  }

  &__button {
    margin-bottom: 60px;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 576px) {
  .error {
    max-width: 100%;
    padding: 24px;
    text-align: center;
  }

  .error_img {
    max-width: 100%;
    width: 100%;
  }
}
</style>
